import {util} from "peerjs";

export const BROWSER = util.browser;
export const browserSupported = util.supports.browser;

export function fireResetNeededEvent() {
  let event = new Event('reset-needed');
  window.dispatchEvent(event);
}